import React from 'react';

// Nút mở Zalo của 1 người: https://zalo.me/<SĐT>. SĐT trong hệ thống = users.user_name (không phải cột phone).
const NutZalo = ({ sdt, nhan = 'Zalo', className = '' }) => {
  if (!sdt) return null;
  return (
    <a href={`https://zalo.me/${sdt}`} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()}
       className={`inline-flex items-center gap-1 rounded-full bg-[#0068FF] text-white text-[11px] font-bold px-1.5 py-0.5 active:scale-95 transition-transform ${className}`}>
      <span className="material-symbols-rounded" style={{ fontSize: 13 }}>chat</span>{nhan}
    </a>
  );
};

// Nút gọi điện: tel: mở trình gọi của máy — iPhone Safari hỏi "Gọi 09…?", Samsung/Chrome Android mở bàn phím gọi.
// KHÔNG target="_blank" (Safari mở tab trắng với tel:). SĐT lưu dạng 84xxxxxxxxx → đổi về +84 để máy nhận đúng.
export const sdtGoi = (sdt) => {
  const so = String(sdt || '').replace(/[^\d+]/g, '');
  if (/^84\d{9}$/.test(so)) return `+${so}`;
  return /^(\+?\d{9,12})$/.test(so) ? so : '';
};
export const NutGoi = ({ sdt, nhan = 'Gọi', className = '' }) => {
  const so = sdtGoi(sdt);
  if (!so) return null;
  return (
    <a href={`tel:${so}`} onClick={(e) => e.stopPropagation()} aria-label={`Gọi ${so}`}
       className={`inline-flex items-center gap-1 rounded-full bg-[#16A34A] text-white text-[11px] font-bold px-1.5 py-0.5 active:scale-95 transition-transform ${className}`}>
      <span className="material-symbols-rounded" style={{ fontSize: 13 }}>call</span>{nhan}
    </a>
  );
};

export default NutZalo;
